<!--
 * @Description: 物料管理
 * @Author:
 * @Date: 2026-04-29
-->
<template>
  <div class="content-view-wrapper pd-10">
    <div
      class="content-view section-wrapper"
      ref="sectionWrapper"
      v-loading="loading"
      :element-loading-background="loadingBackground"
    >
      <!-- 搜索头部 start -->
      <table-title @resize="handleTableTitleResize">
        <template v-slot:operateAction>
          <el-button type="primary" @click="handleAdd(1)" v-has="70">新增</el-button>
        </template>
        <template v-slot:searchForm>
          <el-form class="search-list" ref="searchForm" :model="searchForm">
            <el-form-item class="search-item--1" prop="materialNo">
              <remote-search
                v-model="searchForm.materialNo"
                :remote="true"
                clearable
                placeholder="物料名称"
                title="物料名称"
              ></remote-search>
            </el-form-item>
            <el-form-item class="search-item--1" prop="materialName">
              <el-input
                v-model="searchForm.materialName"
                placeholder="物料名称"
                title="物料名称"
              ></el-input>
            </el-form-item>
            <el-form-item class="search-item--buttons">
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button class="reset" @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </template>
      </table-title>
      <!-- 搜索头部 end -->
      <!-- 表格 start -->
      <section class="table-wrapper">
        <el-table
          border
          :height="resizeViewHeight + 'px'"
          :data="tableData"
          highlight-current-row
          ref="tableList"
          @selection-change="handleSelectionChange"
          row-key="materialDeviceParamId"
          :cell-class-name="isRender"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            label="序号"
            width="80"
            fixed="left"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.sortNum }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            v-for="(column, index) in columnData"
            :key="index"
            :prop="column.fieldName"
            :label="column.fieldLabel"
            :min-width="column.width"
            :align="column.align"
            header-align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row[column.fieldName] }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <e6-td-operate
                v-if="scope.row.materialNo"
                :data="getOperateList(scope.row)"
                @command="handleOperate($event, scope.row)"
              ></e6-td-operate>
            </template>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->

      <!-- 分页 start -->
      <section class="pagination-wrapper fixed-section" ref="paginationWrapper">
        <el-pagination
          :page-size.sync="searchForm.pageSize"
          :current-page.sync="searchForm.pageIndex"
          :page-sizes="pageSizes"
          :layout="layout"
          :total="total"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </section>
      <!-- 分页 end -->
    </div>
    <add-material-device-param
      :addVisible.sync="addVisible"
      :detailInfo="detailInfo"
      @refreshData="queryList"
      :dialogType="dialogType"
      :clickId="clickId"
    ></add-material-device-param>
  </div>
</template>

<script>
import base from "@/mixins/base";
import listPage from "@/mixins/list-page";
import listPageReszie from "@/mixins/list-page-resize";
import { printError } from "@/utils/util";
import {
  getMaterialDeviceParamPage
} from "@/api";
import addMaterialDeviceParam from "./addMaterialDeviceParam.vue";
export default {
  name: "materialDeviceParamManage",
  data() {
    return {
      loading: false,
      queryListAPI: getMaterialDeviceParamPage,
      searchForm: {
        materialNo: "",
        materialName: "",
        pageIndex: 1,
        pageSize: 20
      },
      total: 0,
      columnData: [
        {
          fieldName: "materialNo",
          display: true,
          fieldLabel: "物料编码",
          width: 160,
          align: "center"
        },
        {
          fieldName: "materialName",
          display: true,
          fieldLabel: "物料名称",
          width: 160,
          align: "center"
        },
        {
          fieldName: "deviceParamName",
          display: true,
          fieldLabel: "下发参数",
          width: 180,
          align: "center"
        },
        {
          fieldName: "deviceParamDetail",
          display: true,
          fieldLabel: "参数内容",
          width: 220,
          align: "center"
        }
      ],
      tableData: [],
      dialogType: 1,
      addVisible: false,
      detailInfo: {},
      clickId: ""
    };
  },
  mixins: [listPage, base, listPageReszie],
  components: { addMaterialDeviceParam },
  created() {
    this.queryList();
  },
  activated() {
    this.setScrollRecord();
  },
  methods: {
    getOperateList(row) {
      let operationIds = this.$route.meta.operationIds || [];
      return [
        {
          label: "编辑",
          id: 1,
          disabled: !operationIds.includes(71)
        },
        {
          label: "详情",
          id: 2
        }
      ];
    },
    handleOperate(val, row) {
      this.clickId = row.materialId;
      this.detailInfo = row;
      if (val.id === 1) {
        this.dialogType = 2;
      } else {
        this.dialogType = 3;
      }
      this.addVisible = true;
    },
    handleAdd(type) {
      this.dialogType = type;
      this.clickId = "";
      this.detailInfo = {};
      this.addVisible = true;
    },
    formatList(data) {
      return data.map((item, index) => {
        let startIndex =
          (this.searchForm.pageIndex - 1) * this.searchForm.pageSize;
        if (item.paramList && item.paramList.length) {
          item.children = item.paramList.filter((p, idx) => idx !== 0);
          item.deviceParam = item.paramList[0].deviceParam;
          item.deviceParamName = item.paramList[0].deviceParamName || "";
          item.deviceParamDetail = item.paramList[0].deviceParamDetail || "";
          item.materialDeviceParamId = item.paramList[0].materialDeviceParamId;
        } else {
          item.children = [];
          item.deviceParam = "";
          item.deviceParamName = "";
          item.deviceParamDetail = "";
          item.materialDeviceParamId = `parent_${item.materialNo || index}`;
        }
        item.sortNum = startIndex + index + 1;
        return item;
      });
    },
    isRender({ row }) {
      if (row.materialNo === undefined) {
        return "disabled-column";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.disabled-column .el-checkbox__input {
  display: none !important;
}
</style>
